import { faGithub, faInstagram, faTelegramPlane, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"

import Button from "@material-ui/core/Button"
import Container from "@material-ui/core/Container"
import { ThemeProvider } from "@material-ui/core/styles"
import useTheme from "@material-ui/core/styles/useTheme"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import { graphql, PageProps } from "gatsby"

import React, { useRef } from "react"

import { Helmet } from "react-helmet"

import { Parallax, ParallaxLayer } from "react-spring/renderprops-addons"

import AnimatedContactButtons, { AvatarWithContactButtonsProps } from "../components/AnimatedContactButtons/AnimatedContactButtons"
import Avatar, { AvatarProps } from "../components/Avatar/Avatar"
import HCenter from "../components/HCenter/HCenter"
import coderTheme from "../themes/coderTheme"
import "./index.scss"


export interface HomePageProps extends PageProps {
  data: {
    site: {
      siteMetadata: {
        title: string
        description: string
        url: string
        twitterUsername: string
      }
    }
  } & AvatarProps["data"] & YandexPayFormProps["data"]
}

export default function Home({ data }: HomePageProps) {
  const parallax = useRef<Parallax>()
  const parallaxPages = 3
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("xs"))

  const contacts: AvatarWithContactButtonsProps["contacts"] = [
    { icon: faTwitter, url: "https://twitter.com/ok_thought", color: '#1EA1F1' },
    { icon: faInstagram, url: "https://instagram.com/bogushivan", color: '#ffffff', background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)' },
    { icon: faTelegramPlane, url: "https://t.me/okthought", color: '#ffffff', bgColor: '#27A7E4' },
    { icon: faGithub, url: "https://github.com/OkThought", color: '#ffffff', bgColor: '#242A2E' },
    { icon: faEnvelope, url: "mailto:bogush.vano@gmail.com" },
  ]
  const avatarSize = 25
  const ParallaxLayerContainer = ({ children }) =>
    <Container maxWidth='sm'>
      {children}
    </Container>

  const hey = (
    <ParallaxLayerContainer>
      <Typography variant='h3' color='textSecondary'>
        {"Hey!"}
      </Typography>
      <Typography variant='h6' color='textSecondary'>
        {"I'm Ivan"}
      </Typography>
    </ParallaxLayerContainer>
  )
  const letsGetKnownButton = (
    <ParallaxLayerContainer>
      <Button
        className='text-monospace'
        variant='contained'
        color='primary'
        onClick={() => parallax.current.scrollTo(1)}
      >
        Let's get known :D
      </Button>
    </ParallaxLayerContainer>
  )
  const avatar = (
    <ParallaxLayerContainer>
      <HCenter maxWidth={128}>
        <AnimatedContactButtons size={avatarSize} contacts={contacts}>
          <Avatar data={data} size={100} />
        </AnimatedContactButtons>
      </HCenter>
    </ParallaxLayerContainer>
  )
  const about = (
    <ParallaxLayerContainer>
      <Typography className='pt-5' color='textSecondary' component='div'>
        <p>
          I'm a growth marketer with background in web design and development.
        </p>
        <p>
          I love helping people and businesses make money online.
          From website sales conversion optimization to automating tiresome
          work.
        </p>
        <p>
          I love analytics! It's often mindblowing how much power you can
          unleash by understanding your business data.
        </p>
        <p>
          I'm currently working on a website for my new business. 
        </p>
        <p>
          And I'm not doing it on my own.
          I do it with <a href="https://instagram.com/headvik" target="_blank">Vika</a>. 
          She's the best SMM specialist I know. I've never met a person with her combination of taste, care
          and great experience of growing businesses in Instagram. Don't listen to me, just visit
          her <a href="https://instagram.com/headvik" target="_blank">profile</a> and see yourself :)
        </p>
        <p>
          So Vika and I will soon have something interesting to show you!
        </p>
        <p>
          Stay tuned! ✌️
        </p>
      </Typography>
    </ParallaxLayerContainer>
  )
  const contact = (
    <ParallaxLayerContainer>
      <Typography variant='h6' color='primary'>
        Wanna get in touch?
      </Typography>
      <Typography variant='body1' color='textSecondary' component='p'>
        Feel free to contact me anytime using the bubbles around my avatar at
        the beginning of the page. I'm always glad to have a chat about anything
        be it sowtware, design, marketing, branding, business growth or life, news 
        and you know, the usual stuff :)
      </Typography>
    </ParallaxLayerContainer>
  )

  return (
    <ThemeProvider theme={coderTheme}>
      <div>
        <Helmet>
          <title>{data.site.siteMetadata.title}</title>
          <meta charSet="utf-8" />
          <meta name="description" content={data.site.siteMetadata.description} />
          <meta name="twitter:creator" content={data.site.siteMetadata.twitterUsername} />
          <meta property="og:url" content={data.site.siteMetadata.url} />
          <link rel="canonical" href={data.site.siteMetadata.url} />

          <script type="text/javascript" >
            {`(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

            ym(67442395, "init", {
              clickmap:true,
              trackLinks:true,
              accurateTrackBounce:true
            });`}</script>
        </Helmet>
        <noscript><div><img src="https://mc.yandex.ru/watch/67442395" style={{ position: 'absolute', left: -9999, }} alt="" /></div></noscript>
        <Parallax pages={parallaxPages} ref={parallax}>
          <ParallaxLayer offset={.5} speed={6}>{hey}</ParallaxLayer>
          <ParallaxLayer offset={.7} speed={2} factor={0}>{letsGetKnownButton}</ParallaxLayer>
          <ParallaxLayer offset={smDown ? .2 : .4} speed={1} factor={0}>{avatar}</ParallaxLayer>
          <ParallaxLayer offset={1} speed={.1}>{about}</ParallaxLayer>
          <ParallaxLayer offset={2} speed={1}>{contact}</ParallaxLayer>
        </Parallax>
      </div>
    </ThemeProvider>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        url
      }
    }
  
    avatarImage: file(relativePath: { regex: "/avatar.png/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
